import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export function cardClassName(className?: string) {
  return cn('card', className);
}

export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cardClassName(className)} {...props} />
  ),
);
Card.displayName = 'Card';
